import {
    COUNTRYLISTPARTNER_SUCCESS,
    COUNTRYLISTPARTNER_FAILED,
    RESET_COUNTRYLISTPARTNER,
    LOADING_COUNTRYLISTPARTNER,
    NETWORK_ERROR_COUNTRYLISTPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_COUNTRYLISTPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case COUNTRYLISTPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case COUNTRYLISTPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_COUNTRYLISTPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_COUNTRYLISTPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};